<template>
  <q-layout view="lHh Lpr lFf">
    <q-header :class="{ 'safe-area-header': needInset.android }">
      <q-toolbar>
        <q-toolbar-title class="text-center q-pl-md">
          <span class="sw-title">{{ title }}</span>
        </q-toolbar-title>
        <q-btn
          class="absolute-left"
          flat
          @click="goBack"
          icon="arrow_back_ios"
        />
      </q-toolbar>
    </q-header>
    <q-page-container>
      <router-view @title="setTitle" />
    </q-page-container>
    <q-footer :class="{ 'safe-area-footer': needInset.all }">
    </q-footer>
  </q-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      title: ''
    }
  },
  computed: {
    ...mapGetters({
      qrCode: 'reporter/qrCode',
      needInset: 'common/needInset'
    })
  },
  methods: {
    setTitle(value) {
      this.title = value
    },
    async goBack() {
      if (this.qrCode && this.$route.name === 'audits') {
        this.redirectToPortal()
        return
      }
      this.$router.go(-1)
    },
    async redirectToPortal() {
      const confirmExit = await this.confirmExit()
      if (confirmExit && this.qrCode) {
        window.location.assign(
          `https://portal.sowell.app/location/${this.qrCode}`
        )
        this.$store.dispatch('reporter/setQrCode', null)
        return
      }
    },
    async confirmExit() {
      const hasPendingTask = await this.hasPendingTask()
      let confirmExit = false

      if (hasPendingTask) {
        return new Promise((resolve) => {
          this.$q
            .dialog({
              title: this.$t('common.hasPendingTaskDialog.title'),
              message: this.$t('common.hasPendingTaskDialog.message'),
              cancel: true,
              persistent: true,
              ok: this.$t('common.hasPendingTaskDialog.ok'),
              cancel: {
                label: this.$t('common.hasPendingTaskDialog.cancel'),
                color: 'grey',
                flat: true
              }
            })
            .onOk(() => {
              resolve((confirmExit = false))
              this.$router.push({ name: 'taskList' })
            })
            .onCancel(() => {
              resolve((confirmExit = true))
            })
            .onDismiss(() => {
              resolve((confirmExit = false))
            })
        })
      } else {
        confirmExit = true
      }

      return confirmExit
    },
    async hasPendingTask() {
      const tmpReports = await this.$DB.tmpReports().find({
        selector: {
          status: {
            $in: ['IN_PROGRESS', 'PENDING', 'FAILED'] // NOTE: we treat failed tmpItems as well
          }
        }
      })
      const tmpIssues = await this.$DB.tmpIssues().find({
        selector: {}
      })
      return [...tmpReports.docs, ...tmpIssues.docs].length > 0
    }
  }
}
</script>
